import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["chatCheckbox", "selectControls", "selectAllButton", "viewAllButton"];

  connect() {
    this.isSelected = false;
    this.isAllSelected = false;
    this.viewAll = window.location.href.includes("include_archived=true");
  }

  toggleSelectParentChats() {
    this.isSelected = !this.isSelected;

    // Show or hide checkboxes and controls
    this.chatCheckboxTargets.forEach((field) => {
      field.style.display = this.isSelected ? "inline-block" : "none";
    });
    this.selectControlsTarget.style.display = this.isSelected ? "block" : "none";

    // Prevent clicking chat items when selecting checkboxes
    this.chatCheckboxTargets.forEach((checkbox) => {
      checkbox.addEventListener("click", (e) => e.stopPropagation());
    });
  }

  toggleSelectAllChats() {
    this.isAllSelected = !this.isAllSelected;

    // Toggle the checked state of all checkboxes
    this.chatCheckboxTargets.forEach((field) => {
      field.checked = this.isAllSelected;
    });

    // Update the button text
    this.selectAllButtonTarget.innerText = this.isAllSelected
      ? "Unselect All"
      : "Select All";
  }

  viewAllChats() {
    // Redirect to the view all chats page
    window.location.href = "/text_messages/conversations?include_archived=true";
  }

  viewUnarchivedChats() {
    // Redirect to the view all chats page
    window.location.href = "/text_messages/conversations";
  }

  archiveSelectedChats() {
    const selectedChatIds = Array.from(
      this.chatCheckboxTargets.filter((checkbox) => checkbox.checked)
    ).map((checkbox) => checkbox.value);

    if (selectedChatIds.length === 0) {
      alert("Please select at least one chat to archive.");
      return;
    }

    // Send AJAX request to archive chats
    fetch("/text_messages/archive_selected_chats", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({ chat_ids: selectedChatIds }),
    })
      .then((response) => {
        if (response.ok) {
            window.location.href = "/text_messages/conversations";
        } else {
          response.json().then((data) => {
            alert(data.error || "Failed to archive chats.");
          }).catch(() => {
            alert("Failed to archive chats.");
          });
        }
       
      })
      .catch(() => {
        alert("Failed to archive chats.");
      });
  }
}